/* global chartLanguage, revisedHTML, bocAmchart4, am4core */

/**
 * Function to set up the 'revised' text suffix
 *
 * @returns {string} text to use for balloon if data was revised
 */
bocAmchart4.getRevisedText = function () {
    var revisedText;
    if (typeof (revisedHTML) === 'undefined') {
        revisedText = " [font-weight=bold](revised)[/] ";
        if (chartLanguage === "fr") {
            revisedText = " [font-weight=bold](révisé)[/] ";
        }
    } else {
        revisedText = revisedHTML;
    }
    return revisedText;
};

/**
 * Debounce function to avoid multiple runs
 * @param {function} func function to call
 * @param {integer} wait time to wait
 * @param {bool} immediate flag to run
 * @returns {(function(): void)|*} return instance of function for further debouncing
 */
bocAmchart4.debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
};

/**
 * Re-evaluate shortcode after possible parameter changes
 * @param {object} chart AmChart object
 * @returns {void}
 */
bocAmchart4.reevaluateShortcode = function (chart) {
    while (chart.series.length > 0) {
        chart.series.removeIndex(0);
    }
    chart.colors.startIndex = 0;
    bocAmchart4.vars[chart.bocSettings.id].bulletIndex = 0;

    bocAmchart4.postProcessValetCategories({
        'target': {
            'component': chart,
            'data': chart.bocSettings.dataProcessor.data
        }
    });
    chart.data = chart.bocSettings.interactiveProcessor.originalData;
};

/**
 *
 * @param {object} targetObject object to which to apply the properties
 * @param {string} dataParameter parameter to look in data e.g. for per data point adjustment
 * @param {string | integer | bool} defaultValue default value for data parameter
 * @param {object} optionsObject object containing all the properties and values for all possible values of data parameter
 * @returns {object} modified property
 */
bocAmchart4.setObjectProperties = function (targetObject, dataParameter, defaultValue, optionsObject) {
    // Get initial set of values
    var initialOptions = optionsObject[defaultValue];
    for (var property in initialOptions) {
        // Set initial values for each property
        targetObject[property] = initialOptions[property];
        // Set the adapter to be called on each data point
        targetObject.adapter.add(property, function (varProperty, target, property) {
            // If data context has custom value / override for data parameter,
            // use it's data set to override the property
            if (target.dataItem && target.dataItem.dataContext.hasOwnProperty(dataParameter)) {
                var newProperties = optionsObject[target.dataItem.dataContext[dataParameter]];
                return newProperties[property];
            } else {
                return varProperty;
            }
        });
    }
};

/**
 *
 * @param {object} data to which to add series
 * @param {array} seriesArray Array of objects containing name and label
 * @returns {void}
 */
bocAmchart4.appendSeries = function (data, seriesArray) {
    if (!data.hasOwnProperty('seriesDetail')) {
        data.seriesDetail = {};
    }
    seriesArray.forEach(function (series) {
        data.seriesDetail[series.name] = {'label': series.label};
        data.seriesDetail[series.name].description = series.description ? series.description : "";
        data.seriesDetail[series.name].dimension = series.dimension ? series.dimension
            : data.seriesDetail[Object.keys(data.seriesDetail)[0]].dimension;
    });
};

/**
 *
 * @param {object} data Object valet json data to which to add series
 * @param {array} observationsArray Array of objects containing values by series
 * @returns {void}
 */
bocAmchart4.appendObservations = function (data, observationsArray) {
    if (!data.hasOwnProperty('observations')) {
        data.observations = [];
    }
    observationsArray.forEach(function (observationsSet) {
        let dimension = data.seriesDetail[Object.keys(data.seriesDetail)[0]].dimension.key;
        let updatedObservation = {};
        if (observationsSet.hasOwnProperty(dimension)) {
            updatedObservation[dimension] = observationsSet[dimension].toString();
        } else {
            // no dimension specified so add next one (assume numeric)
            var nextObservationKey = parseInt(data.observations[data.observations.length - 1][dimension]) + 1;
            updatedObservation[dimension] = nextObservationKey.toString();
        }
        for (let series in observationsSet) {
            if (series !== dimension) {
                updatedObservation[series] = {"v": observationsSet[series].toString()};
            }
        }
        data.observations.push(updatedObservation);
    });
};


bocAmchart4.isElementInside = (parent, child) => {
    let parentRect = parent.getBoundingClientRect();
    let childRect = child.getBoundingClientRect();

    return (
        childRect.top >= parentRect.top &&
        childRect.right <= parentRect.right &&
        childRect.bottom <= parentRect.bottom &&
        childRect.left >= parentRect.left
    );
};

/**
 *
 * @param {object} chart AmChart object
 * @returns {void}
 */
bocAmchart4.applyDoughnut = function (chart) {
    chart.innerRadius = am4core.percent(50);
};

/**
 *
 * @param {object} chart AmChart object
 * @returns {void}
 */
bocAmchart4.labelDoughnut = function (chart) {
    if (chart.series.length === 0) {
        return;
    }
    chart.series.getIndex(0).labels.template.maxWidth = 200;
    chart.series.getIndex(0).labels.template.wrap = true;
    chart.series.getIndex(0).labels.template.text = "{category}";
    chart.series.getIndex(0).labels.template.disabled = false;
    chart.series.getIndex(0).ticks.template.disabled = false;
};

/**
 *
 * @param {object} chart AmChart object
 * @returns {void}
 */
bocAmchart4.hideLabels = function (chart) {
    if (chart.series.length === 0) {
        return;
    }
    chart.series.getIndex(0).labels.template.disabled = true;
    chart.series.getIndex(0).ticks.template.disabled = true;
};

/**
 *
 * @param {object} chart AmChart object
 * @returns {void}
 */
bocAmchart4.showLabels = function (chart) {
    if (chart.series.length === 0) {
        return;
    }
    chart.series.getIndex(0).labels.template.disabled = false;
    chart.series.getIndex(0).ticks.template.disabled = false;
};

bocAmchart4.computeDisplayPieLabels = function (chart, event, hideWidth) {
    if (!hideWidth) {
        let toHide = false;
        let parentNode = chart.element.node.parentNode.parentNode.parentNode.firstChild;
        //check all labels in the chart, and see if they are still inside the bounds of the container
        for (let ind = 0; ind < chart.series.getIndex(0).dataItems.length; ind++) {
            let childNode = chart.series.getIndex(0).dataItems.getIndex(ind).label.element.node;
            if (!bocAmchart4.isElementInside(parentNode, childNode)) {
                toHide = true;
                break;
            }
        }
        if (toHide) {
            bocAmchart4.hideLabels(chart);
        } else {
            bocAmchart4.showLabels(chart);
        }
    } else {
        //this is the case that a custom width has been provided. we should only hide the labels when the width is less than the provided width
        if (event.target.contentWidth <= hideWidth) {
            bocAmchart4.hideLabels(chart);
        } else {
            bocAmchart4.showLabels(chart);
        }
    }
};

/**
 * Polyfill to allow date encoded numbers in Amcharts4
 * @param {object} data - data object
 * @returns {object} processedData - data object
 */
bocAmchart4.preprocessDateEncoded = function (data) {
    for (const series in data.seriesDetail) {
        data.seriesDetail[series].dimension.key = 'k';
    }
    data.observations.forEach(function (item, index) {
        var date = new Date(data.observations[index]['d'] + 'T00:00:00.000Z');

        data.observations[index]['k'] = date.getUTCFullYear() - 2000 +
            date.getUTCMonth() / 12 + (date.getUTCDate() - 1) / 12 / 30;
    });

    return data;
};

/**
 * Hide legend for the chart if single series (used in interactive charts)
 * @param {object} chart - chart object
 * @returns {undefined} void function
 */
bocAmchart4.hideLegendIfSingle = function (chart) {
    if (chart.legend) {
        chart.legend.events.on("validated", function (ev) {
            if (ev.target.markers.length === 1) {
                chart.legend.hide();
                // var legendID = chart.bocSettings.id + "-legend";
                // document.getElementById(legendID).style.height = "0px";
            } else {
                chart.legend.show();
            }
        });
    }
};

/**
 * Grabs the title of the given chart
 * @param {object} chart - chart object
 * @returns {string} title of the chart. If the title is not found, returns "AmCharts4"
 */
bocAmchart4.getChartTitle = function (chart) {
    let title;
    if (chart.title.children.length > 0 && chart.title.children.getIndex(0)?.text) {
        // Grabbing title from chart instead of bocSettings in case the title was processed
        title = chart.title.children.getIndex(0).text;
    } else if (chart.bocSettings.args.hasOwnProperty('charttitle') && chart.bocSettings.args.charttitle !== '') {
        title = chart.bocSettings.args.charttitle;
    } else if (chart.bocSettings.args.hasOwnProperty('subtitle') && chart.bocSettings.args.subtitle !== '') {
        title = chart.bocSettings.args.subtitle;
    } else {
        title = "AmCharts4";
    }
    return title;
};
